<template>
  <div :class='componentClasses'>
    <div class='result-wrapper'>
    <div class="result-description">
      <div class="result-prelude">
        <h2>{{ config.preludeQuestion }}</h2>
      </div>
      <div class="result-question">
        {{ questionText}}
      </div>
      <div class="result-prelude">
        <h2>{{ config.preludeAnswer }}</h2>
      </div>
      <div class="result-answer">
        {{ answer }}
      </div>
    </div>

    <div class="result-data">
      <result-circle :config='circleConfig()' :progress='progress' :title='circleTitle' :text='circleText'></result-circle>
      <p class='result-agreement-message'>{{ config.message }}</p>
    </div>
    <div class="comp-type" v-if='debugMode == true'>
      <slot name='comptype'></slot>
    </div>
  </div>
  </div>
</template>
<script>
import Circle from './Circle'
import Scoring from '../lib/Scoring.js'
export default {
  props: ['config', 'result'],
  mixins: [Scoring],
  components: {
    'result-circle': Circle
  },
  data () {
    return {
      componentClasses: ['result-agreement-component', 'result-component'],
      questionText: '',
      progress: 0,
      answer: '',
      ready: false,
      circleTitle: '',
      circleText: ''
    }
  },
  methods: {
    circleConfig () {
      return {
        stroke: this.theme.accent.color,
        width: this.theme.borders.thickness
      }
    },
    onInit (event) {
      this.ready = true
    }
  },
  created () {
    this.question = this.questionForKey(this.config.key)
    this.questionText = this.question.options.question
    this.circleTitle = (this.progress * 100).toFixed(0) + '%'
    this.circleText = ''
  },
  watch: {
    result: function (newResult, oldResult) {
      this.progress = (newResult.agreement.questions[this.config.key].pc)
      this.circleTitle = (this.progress * 100).toFixed(0) + '%'
      this.answer = newResult.agreement.questions[this.config.key].answer
    }
  }
}
</script>
<style lang='scss'>
.result-resultagreement {
  .result-wrapper {
    padding: 1rem;
    display: flex;
    width: 85%;
    margin: auto;
    .result-description {
      flex: 0 0 65%;
      text-align: left;
    }
    .result-data {
      flex: 0 0 35%;
    }
  }
}
@media screen and (min-width: 1024px) {
.result-resultagreement {
  .result-wrapper {
    width: 100%;
    max-width:1000px;
    padding: 5%;
    margin:auto;
    .result-description {
      flex: 0 0 70%;
      text-align: left;
    }
    .result-data {
      flex: 0 0 30%;
    }
  }
}
}

</style>
